import { render, staticRenderFns } from "./Class404.vue?vue&type=template&id=39debacc&scoped=true"
import script from "./Class404.vue?vue&type=script&lang=js"
export * from "./Class404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39debacc",
  null
  
)

export default component.exports